import grapesjs from 'grapesjs';
// import grapesjs from './grapesjs';

const stopPropagation = e => e.stopPropagation();

export default grapesjs.plugins.add('gjs-plugin-rte', (editor, opts = {}) => {
  const rte = editor.RichTextEditor;
  const btnState = {
    ACTIVE: 1,
    INACTIVE: 0,
    DISABLED: -1
  };


  editor.RichTextEditor.remove('link');


  const isValidAnchor = rte => {
    // console.log('component', component)

    const anchor = rte.selection().anchorNode;
    const parentNode = anchor && anchor.parentNode;
    const nextSibling = anchor && anchor.nextSibling;
    return (
      // (component && component.attributes.tagName == 'a') ||
      (parentNode && parentNode.nodeName == 'A') ||
      (nextSibling && nextSibling.nodeName == 'A')
    );
  };

  // rte.add('toggleAnchor', {
  //   icon: `<span style="transform:rotate(45deg)">&supdsub;</span>`,
  //   state: (rte, doc) => {
  //    if (rte && rte.selection()) {
  //      // `btnState` is a integer, -1 for disabled, 0 for inactive, 1 for active
  //      return isValidAnchor(rte) ? btnState.ACTIVE : btnState.INACTIVE;
  //    } else {
  //      return btnState.INACTIVE;
  //    }
  //   },
  //   result: (rte, action) => {
  //     if (isValidAnchor(rte)) {
  //       rte.exec('unlink');
  //     } else {
  //       rte.insertHTML(`<a class="link" href="">${rte.selection()}</a>`);
  //     }
  //   }
  // })

  

// editor.RichTextEditor.add('fontstyle',
// {
//   icon: '<b>S<sup>s</sup></b>',
//   attributes: {title: 'Font style'},
//   // result: rte => rte.exec('formatBlock', '<font>')
//   // result: rte => rte.exec('fontSize', 'inherit')
//   result: rte => {
//     const html = `<a class="link selected0" href="#">${rte.selection()}</a>`;
//     // const html = `<font class="link selected" href="#">${rte.selection()}</font>`;
//     // const html = `<u class="selected">${rte.selection()}</u>`;
//     rte.insertHTML(html);
//     // rte.exec('foreColor', '#F00')
//     const selectedText      = editor.getSelected();
//     selectedText.trigger('sync:content');
//   }
// });

// editor.RichTextEditor;
// rte.add('colorBackground',
//       {
//         icon: 'CB',
//         attributes: {title: 'colorBackground'},
//         result: rte =>
//         {
//           const html = `<a style="color:red;background:green;" class="link selected" href="#">${rte.selection()}</a>`;
//           rte.insertHTML(html);
//           const selectedText      = editor.getSelected();
//           const selectedTextInner = rte.el.innerHTML;
//           selectedText.set('content', selectedTextInner);
//           selectedText.trigger('sync:content');
//           /*editor.select(selectedText.find('.selected'));
//           editor.getSelected().removeClass('selected');*/
//         }
//       });
// An example with fontSize


  editor.RichTextEditor.add('hyperlink', {
    // icon: '&#128279;',
    icon: '<i class="fa fa-link" style="font-size: 13px;"></i>',
    attributes: {title: 'Lien'},
    state: (rte, doc) => {
      var component = editor.getSelected();

      if(component && component.is('link')) {
        return btnState.ACTIVE
      }
      else if (rte && rte.selection()) {
        return isValidAnchor(rte) ? btnState.ACTIVE : btnState.INACTIVE;
      } 
      else {
        return btnState.INACTIVE;
      }
    },
    result: rte => {
      var component = editor.getSelected();
      
      if(component && component.is('link')) {
        let container = component.getEl()
        if(!container) return
        const content = component.get('content');
        var fontEl = document.createElement("font");
        fontEl.innerHTML = content
        container.replaceWith(fontEl)
      }
      // else if (rte && rte.selection()) {
      //   let sel = rte.selection();
      //   rte.exec('unlink');
      // }
      else {
        var url = window.prompt('Enter the URL to link to:');
        if (url) {
          rte.insertHTML(`<a class="link" href="${url}">${rte.selection()}</a>`);
        }
        else {
          rte.insertHTML(`<a class="link" href="">${rte.selection()}</a>`);
        }
      }
    }
  });

  editor.RichTextEditor.add('erase', {
    icon: '<i class="fa fa-eraser"></i>',
    attributes: {title: 'Effacer le formattage'},
    result: rte => {
      rte.exec('removeFormat');
    }
  });

  editor.RichTextEditor.add('block-style', {
    icon: '<i class="fa fa-square-o"></i>',
    attributes: {title: 'Ajouter un block text'},
    result: rte => {
      var component = editor.getSelected();
      // console.log('component', component);
      // console.log('editor', editor);
      console.log('editor', editor.Canvas.getCanvasView());

      // if(!component){
        // rte.exec('formatBlock', '<font>');

        let sel = rte.selection();
        // rte.insertHTML(`<a>${sel}</a>`);
        // rte.insertHTML(`<span>${sel}</span>`);
        rte.insertHTML(`<font>${sel}</font>`);
        sel = rte.selection();
        // console.log('sel', sel);

        // const selectedText      = editor.getSelected();
        // selectedText.trigger('sync:content');

        // component.update()
      // }
      // let container = component.getEl()
      // if(!container) return
      // const content = component.get('content');
      // var fontEl = document.createElement("font");
      // fontEl.innerHTML = content
      // container.replaceWith(fontEl)
    }
  });

rte.add('fontSize', {
  icon: `<select class="gjs-field"
  style="color: #fff;">
        <option value="0" selected>Auto</option>
        <option value="1">10</option>
        <option value="2">13</option>
        <option value="3">16</option>
        <option value="4">18</option>
        <option value="5">24</option>
        <option value="6">32</option>
        <option value="7">48</option>
      </select>`,
    // Bind the 'result' on 'change' listener
  event: 'change',
  attributes: {title: 'Taille'},
  result: (rte, action) => {
    let val = parseInt(action.btn.firstChild.value)
    if(val){
      rte.exec('fontSize', val)
    }
    else {
      // rte.exec('fontSize', 'inherit')
      // console.log('removeFormat');
      rte.exec('removeFormat');
      // let container = component.getEl()
      // if(!container) return
      // const content = component.get('content');
      // var fontEl = document.createElement("font");
      // span.innerHTML = content
      // container.replaceWith(font)
    }
  },
  // Callback on any input change (mousedown, keydown, etc..)
  update: (rte, action) => {
    const value = rte.doc.queryCommandValue(action.name);
    if (value != 'false') { // value is a string
      action.btn.firstChild.value = value;
    }
  }
})

rte.add('foreColor', {
  icon: `<input type="color" style="width: 23px;" class="gjs-field" value="">`,
  event: 'change',
  attributes: {title: 'Couleur'},
  result: (rte, action) => {
    rte.exec('foreColor', action.btn.firstChild.value)
  },
  update: (rte, action) => {
    const value = rte.doc.queryCommandValue(action.name);
    if (value != 'false') { // value is a string
      action.btn.firstChild.value = value;
    }
  }
})


  editor.RichTextEditor.add('indent',
  {
    icon: '&#8594;',
    attributes: {title: 'Indent'},
    result: rte => rte.exec('indent')
  });

  editor.RichTextEditor.add('outdent',
  {
    icon: '&#8592;',
    attributes: {title: 'Outdent'},
    result: rte => rte.exec('outdent')
  });

  editor.RichTextEditor.add('orderedList',
  {
    icon: '1.',
    attributes: {title: 'Ordered List'},
    result: rte => rte.exec('insertOrderedList')
  });

  editor.RichTextEditor.add('unorderedList',
  {
    icon: '&#8226;',
    attributes: {title: 'Unordered List'},
    result: rte => rte.exec('insertUnorderedList')
  });


  // var defaultType = editor.DomComponents.getType("default");
  // var textType = editor.DomComponents.getType("text");

  // editor.DomComponents.addType("span", {
  //   model: textType.model.extend({
  //     defaults: {
  //       type: "text",
  //       removable: false,
  //       draggable: false,
  //       droppable: false,
  //       badgable: true,
  //       stylable: true,
  //       'stylable-require': '',
  //       'style-signature': '',
  //       // unstylable: '',
  //       highlightable: true,
  //       copyable: false,
  //       resizable: false,
  //       editable: true,
  //       layerable: false,
  //       selectable: true,
  //       hoverable: false,
  //       traits: [],
  //     },
  //   },
  //   {
  //     isComponent: function(el){
  //       console.log('stet',el)
  //       if(!el.tagName) return false

  //       return el.tagName.toLowerCase() == 'span'
  //     }
  //   }),
  //   // view: defaultType.view
  // });
});